<p>
  <ngb-progressbar type="primary" [value]="value"></ngb-progressbar>
</p>
